// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Ow","widget":"e_Pw","title":"e_Qw","msrp":"e_Rw","separator":"e_Sw","textBadge":"e_Tw"};